(() => {
  const normalizeText = (value) => String(value || '')
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  /* Canonical vocabulary used in Shopify orders. The storefront can stay in
     the customer's language; fulfillment always receives these English terms. */
  const dictionary = {
    silber: 'Silver', rosegold: 'Rose gold', januar: 'January', februar: 'February', marz: 'March', maerz: 'March', juni: 'June', juli: 'July', oktober: 'October', dezember: 'December',
    'gold - feine kette': 'Gold - fine chain', 'gold - breite kette': 'Gold - wide chain',
    'silber - feine kette': 'Silver - fine chain', 'silber - breite kette': 'Silver - wide chain',
    gold: 'Gold', oro: 'Gold', or: 'Gold',
    silver: 'Silver', plata: 'Silver', argent: 'Silver', argento: 'Silver',
    'rose gold': 'Rose gold', 'oro rosa': 'Rose gold', 'or rose': 'Rose gold', 'oro rosato': 'Rose gold',
    january: 'January', enero: 'January', janvier: 'January', gennaio: 'January',
    february: 'February', febrero: 'February', fevrier: 'February', febbraio: 'February',
    march: 'March', marzo: 'March', mars: 'March',
    april: 'April', abril: 'April', avril: 'April', aprile: 'April',
    may: 'May', mayo: 'May', mai: 'May', maggio: 'May',
    june: 'June', junio: 'June', juin: 'June', giugno: 'June',
    july: 'July', julio: 'July', juillet: 'July', luglio: 'July',
    august: 'August', agosto: 'August', aout: 'August',
    september: 'September', septiembre: 'September', septembre: 'September', settembre: 'September',
    october: 'October', octubre: 'October', octobre: 'October', ottobre: 'October',
    november: 'November', noviembre: 'November', novembre: 'November',
    december: 'December', diciembre: 'December', decembre: 'December', dicembre: 'December',
    'gold - fine chain': 'Gold - fine chain', 'oro - eslabon fino': 'Gold - fine chain',
    'or - chaine fine': 'Gold - fine chain', 'oro - catena sottile': 'Gold - fine chain',
    'or - maille fine': 'Gold - fine chain', 'oro - maglia fine': 'Gold - fine chain',
    'gold - wide chain': 'Gold - wide chain', 'oro - eslabon ancho': 'Gold - wide chain',
    'or - chaine large': 'Gold - wide chain', 'oro - catena larga': 'Gold - wide chain',
    'or - maille large': 'Gold - wide chain', 'oro - maglia larga': 'Gold - wide chain',
    'silver - fine chain': 'Silver - fine chain', 'plata - eslabon fino': 'Silver - fine chain',
    'argent - chaine fine': 'Silver - fine chain', 'argento - catena sottile': 'Silver - fine chain',
    'argent - maille fine': 'Silver - fine chain', 'argento - maglia fine': 'Silver - fine chain',
    'silver - wide chain': 'Silver - wide chain', 'plata - eslabon ancho': 'Silver - wide chain',
    'argent - chaine large': 'Silver - wide chain', 'argento - catena larga': 'Silver - wide chain',
    'argent - maille large': 'Silver - wide chain', 'argento - maglia larga': 'Silver - wide chain'
  };

  const sizeDetails = {
    S: 'EU51 / HK12 / US5.5',
    M: 'EU54 / HK15 / US6.75',
    L: 'EU60 / HK20 / US9'
  };

  const translateValue = (value) => {
    const original = String(value || '').trim();
    const normalized = normalizeText(original).replace(/\s*[-\u2010-\u2015\u2212]\s*/g, ' - ');
    if (dictionary[normalized]) return dictionary[normalized];
    const letters = original.match(/^(\d+)\s+(?:letras?|lettres?|letter[ae]|letters?|Buchstaben?)(?:\s*\(\+\s*(?:(?:CHF|EUR|USD|[€$])\s*)?\d+(?:[.,]\d+)?\s*(?:CHF|EUR|USD|[€$])?\))?$/i);
    if (letters) return `${letters[1]} ${letters[1] === '1' ? 'letter' : 'letters'}`;
    const stones = original.match(/^(\d+)\s+(?:piedras?\s+de\s+nacimiento|pierres?\s+de\s+naissance|pietr[ae]\s+di\s+nascita|birthstones?|Geburtssteine?)(?:\s*\(\+\s*(?:(?:CHF|EUR|USD|[€$])\s*)?\d+(?:[.,]\d+)?\s*(?:CHF|EUR|USD|[€$])?\))?$/i);
    if (stones) return `${stones[1]} ${stones[1] === '1' ? 'birthstone' : 'birthstones'}`;
    const nameplates = original.match(/^(\d+)\s+(?:placas?|plaques?|targhett[ae]|nameplates?|(?:Namens)?plättchen)(?:\s*\(\+\s*(?:(?:CHF|EUR|USD|[€$])\s*)?\d+(?:[.,]\d+)?\s*(?:CHF|EUR|USD|[€$])?\))?$/i);
    if (nameplates) return `${nameplates[1]} ${nameplates[1] === '1' ? 'nameplate' : 'nameplates'}`;
    const charms = original.match(/^(\d+)\s+(?:charms?|medallas?|médailles?|pendentifs?|colgantes?|ciondol[oi]|Anhänger|Medaillons?)(?:\s*\(\+\s*(?:(?:CHF|EUR|USD|[€$])\s*)?\d+(?:[.,]\d+)?\s*(?:CHF|EUR|USD|[€$])?\))?$/i);
    if (charms) return `${charms[1]} ${charms[1] === '1' ? 'charm' : 'charms'}`;
    return original;
  };

  const translateKey = (key) => {
    const text = String(key || '').trim();
    const normalized = normalizeText(text)
      .replace(/(?:namens)?plattchen/g, 'nameplate')
      .replace(/geburtssteine?/g, 'birthstone')
      .replace(/buchstaben?/g, 'letter')
      .replace(/anhanger|medaillons?/g, 'charm')
      .replace(/armband/g, 'bracelet')
      .replace(/gravur/g, 'engraving')
      .replace(/\banzahl(?: der)?\b/g, 'number')
      .replace(/\b(?:linke[rsn]?|links)\b/g, 'left')
      .replace(/\b(?:rechte[rsn]?|rechts)\b/g, 'right')
      .replace(/\bobere[rsn]?\b/g, 'top')
      .replace(/\bmittlere[rsn]?\b/g, 'middle')
      .replace(/\buntere[rsn]?\b/g, 'bottom')
      .replace(/farbe/g, 'color')
      .replace(/grosse|groesse/g, 'size')
      .replace(/^stil$/, 'style')
      .replace(/^name oder wort$/, 'name or word')
      .replace(/^name auf (?:dem )?nameplate/, 'name on nameplate');
    const number = normalized.match(/(?:^|\s)(\d+)\s*$/)?.[1] || normalized.match(/^(?:bracelet|pulsera|bracciale)\s+(\d+)\b/)?.[1];
    const left = /\b(left|izquierd[ao]|gauche|sinistr[ao])\b/.test(normalized);
    const right = /\b(right|derech[ao]|droite?|destr[ao])\b/.test(normalized);

    if (/^(?:nombre (?:en|de) la placa|nom sur la plaque|nome sulla targhetta|name on nameplate|nameplate)(?:\s+\d+)?$/.test(normalized)) return number ? `Nameplate ${number}` : 'Name on nameplate';
    const charmInitial = normalized.match(/^(?:charm|medalla|medaille|pendentif|colgante|ciondolo)\s+(\d+)\s+(?:initial|inicial|initiale|iniziale)$/);
    if (charmInitial) return `Charm ${charmInitial[1]} initial`;
    if (/^(?:charm|medalla|medaille|pendentif|colgante|ciondolo)(?:\s+\d+)?$/.test(normalized)) return number ? `Charm ${number}` : 'Charm';
    if (/^(color|couleur|colore)$/.test(normalized)) return 'Color';
    if (/^(size|talla|taille|taglia)$/.test(normalized)) return 'Size';
    if (/^(number|numero|nombre)\b/.test(normalized)) {
      if (/(birthstone|piedra|pierre|pietr[ae])/.test(normalized) && /(letter|letra|lettre|lettera)/.test(normalized)) return 'Number of letters/birthstones';
      if (/(birthstone|piedra|pierre|pietr[ae])/.test(normalized)) return 'Number of birthstones';
      if (/(nameplate|placa|plaque|targhett[ae])/.test(normalized)) return 'Number of nameplates';
      if (/(charm|medalla|medaille|pendentif|ciondol[oi])/.test(normalized)) return 'Number of charms';
      if (/(letter|letra|lettre|lettera)/.test(normalized)) return 'Number of letters';
    }
    if (/(initial|initiale|iniziale|inicial)/.test(normalized)) {
      if (left) return 'Left initial';
      if (right) return 'Right initial';
      if (/superior|upper|\bhaute?\b|alto|top/.test(normalized)) return 'Top initial';
      if (/central|middle|milieu|centro/.test(normalized)) return 'Middle initial';
      if (/inferior|lower|\bbas(?:se)?\b|basso|bottom/.test(normalized)) return 'Bottom initial';
      if (/charm|medalla|medaille|pendentif|ciondolo/.test(normalized)) return `Charm ${number || ''} initial`.trim();
    }
    if (/(birthstone|piedra|pierre|pietra)/.test(normalized)) {
      if (left) return 'Left birthstone';
      if (right) return 'Right birthstone';
      if (/(letter|letra|lettre|lettera)/.test(normalized)) return number ? `Letter/birthstone ${number}` : 'Letter/birthstone';
      return number ? `Birthstone ${number}` : 'Birthstone';
    }
    if (/(letter|letra|lettre|lettera)/.test(normalized)) {
      if (/superior|upper|\bhaute?\b|alto|top/.test(normalized)) return 'Top initial';
      if (/central|middle|milieu|centro/.test(normalized)) return 'Middle initial';
      if (/inferior|lower|\bbas(?:se)?\b|basso|bottom/.test(normalized)) return 'Bottom initial';
      return number ? `Letter ${number}` : 'Letter';
    }
    if (/(bracelet|pulsera|bracciale)/.test(normalized)) {
      const bracelet = number ? `Bracelet ${number}` : 'Bracelet';
      if (/(color|couleur|colore)/.test(normalized)) return `${bracelet} color and chain`;
      if (left || /izquierd|gauch|sinistr/.test(normalized)) return `${bracelet} left engraving`;
      if (right || /derech|droit|destr/.test(normalized)) return `${bracelet} right engraving`;
    }
    if (/(nameplate|placa|plaque|targhetta)/.test(normalized) && /(name|nombre|nom|nome)/.test(normalized)) return number ? `Nameplate ${number}` : 'Name on nameplate';
    if (/^(style|estilo|stile)$/.test(normalized)) return 'Style';
    if (/^(name|nombre|nom|nome)(?:\s+(?:or|o|ou)\s+(?:word|palabra|mot|parola))?$/.test(normalized)) return 'Name or word';
    if (/(engraving|grabado|gravure|incisione)/.test(normalized)) {
      if (left) return 'Left engraving';
      if (right) return 'Right engraving';
      return 'Engraving';
    }
    return text;
  };

  const propertyValue = (key, value) => {
    if (key === 'Style') {
      const style = normalizeText(value).match(/^schrift(?:art)?\s*([1-5])\s*[-–—]\s*(?:schwungvoll|anmutig|verspielt|elegant|klassisch|minimalistisch)$/);
      if (style) return ['FONT 1 - GRACEFUL', 'FONT 2 - PLAYFUL', 'FONT 3 - ELEGANT', 'FONT 4 - CLASSIC', 'FONT 5 - MINIMALIST'][Number(style[1]) - 1];
    }
    if (key === 'Size') {
      const size = String(value || '').trim();
      if (sizeDetails[size]) return sizeDetails[size];
      const legacy = size.match(/^([SML]) \(EU \d+ \/ HK \d+ \/ US [\d.]+, \d+ mm circumference, approx\. \d+ mm diameter\)$/);
      if (legacy) return sizeDetails[legacy[1]];
    }
    if (/^(?:Nameplate(?: \d+)?|Name on nameplate|Name or word|(?:.* )?engraving|Engraving|(?:Left|Right|Top|Middle|Bottom) initial|Letter(?: \d+)?|Charm \d+ initial)$/i.test(key)) return String(value);
    return translateValue(value);
  };

  const normalizeProperties = (properties) => {
    const result = {};
    Object.entries(properties || {}).forEach(([rawKey, rawValue]) => {
      if (rawKey === '_Offer') return;
      if (rawValue === undefined || rawValue === null || String(rawValue).trim() === '') return;
      const isPrivate = String(rawKey).startsWith('_');
      const baseKey = isPrivate ? String(rawKey) : translateKey(rawKey);
      let key = baseKey;
      let suffix = 2;
      while (Object.prototype.hasOwnProperty.call(result, key)) key = `${baseKey} ${suffix++}`;
      result[key] = isPrivate ? String(rawValue) : propertyValue(baseKey, rawValue);
    });
    return result;
  };


  const privateStoneTestEnabled = false;
  const isStoneKey = key => /^(?:(?:Left|Right) birthstone|Birthstone(?: [1-6])?)$/.test(key);
  const serializeBirthstones = (properties) => {
    const other = {}, stones = new Map();
    for (const [key, value] of Object.entries(properties || {})) {
      if (key.startsWith('_') && isStoneKey(key.slice(1))) stones.set(key.slice(1), value);
    }
    for (const [key, value] of Object.entries(properties || {})) {
      if (key.startsWith('_') && isStoneKey(key.slice(1))) continue;
      const canonical = key.startsWith('_') ? key : translateKey(key);
      if (isStoneKey(canonical)) stones.set(canonical, value);
      else other[key] = value;
    }
    const result = normalizeProperties(other);
    for (const [key, value] of stones) {
      if (value !== undefined && value !== null && String(value).trim()) result[key] = translateValue(value);
    }
    return result;
  };
  const orderProperties = serializeBirthstones;

  const optionNames = (form) => {
    const names = [];
    [...form.elements].forEach((control) => {
      const name = String(control.name || '');
      const optionMatch = name.match(/^options\[([^\]]+)\]$/);
      if (optionMatch) names.push(optionMatch[1]);
      else if (/^(Color|Couleur|Colore|Farbe|Talla|Taille|Taglia|Size|Grösse|Groesse)$/i.test(name)) names.push(name);
    });
    return [...new Set(names)];
  };

  const selectedValue = (form, name) => {
    const controls = [...form.elements].filter((control) => control.name === name || control.name === `options[${name}]`);
    for (const control of controls) {
      if (control.disabled || ((control.type === 'radio' || control.type === 'checkbox') && !control.checked)) continue;
      if (control.value) return control.value;
    }
    return '';
  };

  const collectDetails = (form) => {
    const details = [];
    const keys = new Set();
    const add = (rawKey, rawValue) => {
      let key = translateKey(rawKey);
      const value = key === 'Size' && sizeDetails[rawValue] ? sizeDetails[rawValue] : propertyValue(key, rawValue);
      if (!key || !value || value === 'Default Title') return;
      if (keys.has(key)) {
        let index = 2;
        while (keys.has(`${key} ${index}`)) index += 1;
        key = `${key} ${index}`;
      }
      keys.add(key);
      details.push({ key, value });
    };

    optionNames(form).forEach((name) => add(name, selectedValue(form, name)));
    [...form.elements].forEach((control) => {
      const match = String(control.name || '').match(/^properties\[([^\]]+)\]$/);
      if (!match || match[1].startsWith('_') || control.disabled || !String(control.value || '').trim()) return;
      if ((control.type === 'radio' || control.type === 'checkbox') && !control.checked) return;
      add(match[1], control.value);
    });
    return details;
  };

  const build = (output) => {
    const form = output.form || document.getElementById(output.getAttribute('form'));
    if (!form) return [];
    const details = collectDetails(form);
    output.value = details.map(({ key, value }) => `${key}: ${value}`).join('\n');
    return details;
  };

  const setOrderProperties = (event, form) => {
    const details = collectDetails(form);
    [...event.formData.keys()].forEach((name) => {
      if (/^properties\[[^_][^\]]*\]$/.test(name)) event.formData.delete(name);
      const privateKey = name.match(/^properties\[_([^\]]+)\]$/)?.[1];
      if (privateKey && isStoneKey(privateKey)) event.formData.delete(name);
    });
    event.formData.delete('properties[_Supplier details]');
    event.formData.delete('properties[_Offer]');
    const properties = orderProperties(Object.fromEntries(details.map(({ key, value }) => [key, value])));
    Object.entries(properties).forEach(([key, value]) => event.formData.set(`properties[${key}]`, value));
  };

  const initialize = () => {
    document.querySelectorAll('form[data-type="add-to-cart-form"], form[action*="/cart/add"]').forEach((form) => {
      if (form.dataset.mvSupplierReady) return;
      form.dataset.mvSupplierReady = 'true';
      form.addEventListener('formdata', (event) => setOrderProperties(event, form));
    });
    document.querySelectorAll('[data-mv-supplier-details]').forEach(build);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  const updateAll = () => {
    initialize();
    document.querySelectorAll('[data-mv-supplier-details]').forEach(build);
  };
  document.addEventListener('change', updateAll, true);
  document.addEventListener('input', updateAll, true);
  new MutationObserver(initialize).observe(document.documentElement, { childList: true, subtree: true });
  window.MiravelSupplierDetails = Object.freeze({ normalizeKey: translateKey, normalizeValue: translateValue, normalizeProperties, orderProperties, serializeBirthstones, privateStoneTestEnabled });
})();
